import { connect } from "react-redux";
import Component from "./StockManagementPage";

export default connect(
    null,
    ({ scp: { checkTerminals }, scp: { addStock }, alert: { silence } }) => ({ checkTerminals, addStock, silence })
)(Component);
